import axios from 'axios'

const fetchPDFDataWithCoordinates = async payload => {
  const accessToken = localStorage.getItem('access_token')
  const refreshToken = localStorage.getItem('refresh_token')
  const headers = {
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken,
    Accept: 'application/json'
  }
  try {
    const response = await axios.get(
      `https://insureai-intake-dev-1074099157700.us-central1.run.app/application_mapping/mappings/with_coordinates?doc_id=${payload.doc_id}&application_id=${payload.application_id}&page_number=${payload.pageNumber}`,
      { headers }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching PDF JSON data:', error)
  }
}

const fetchPDFDataWithOutCoordinates = async payload => {
  const accessToken = localStorage.getItem('access_token')
  const refreshToken = localStorage.getItem('refresh_token')
  const headers = {
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken,
    Accept: 'application/json'
  }
  try {
    const response = await axios.get(
      `https://insureai-intake-dev-1074099157700.us-central1.run.app/application_mapping/mappings/without_coordinates?doc_id=${payload.doc_id}&application_id=${payload.application_id}&page_number=${payload.pageNumber}`,
      { headers }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching PDF JSON data:', error)
  }
}

const transformDataWithCoordinates = input => {
  const output = []

  // Create a new object to hold the transformed data
  const transformedObject = {}

  // Iterate over each item in the input array
  input.forEach(item => {
    // Destructure the necessary properties from the item
    const { key, value, x1, y1, x2, y2 } = item

    // Create a new entry in the transformed object for each key
    transformedObject[key] = {
      value: value,
      coordinates: {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      }
    }
  })

  // Push the transformed object into the output array
  output.push(transformedObject)

  return output
}

const transformDataWithOutCoordinates = input => {
  // Initialize an empty array to hold the transformed result
  const result = []

  // Create an object to hold the transformed key-value pairs
  const transformedObject = {}

  // Iterate over each item in the input array
  input.forEach(item => {
    const { key, value, id } = item

    // Assign the value to the corresponding key in the transformed object
    transformedObject[key] = `${value}$$${id}`
  })

  // Push the transformed object into the result array
  result.push(transformedObject)

  return result
}

export {
  fetchPDFDataWithCoordinates,
  fetchPDFDataWithOutCoordinates,
  transformDataWithCoordinates,
  transformDataWithOutCoordinates
}
